import '@rabbit/utils/sentry';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';

import './grease_setup';
import App from './app/app';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);
